export default {"src":"/_next/static/media/whatsapp-icon.35754a54.svg","height":48,"width":48,"blurWidth":0,"blurHeight":0};